class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.querySelector('#close-cart-drawer').addEventListener('click', this.close.bind(this));
        this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        if (!cartLink) return;

        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(cartLink);
        });
        cartLink.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(cartLink);
            }
        });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

        setTimeout(() => {
            let openCartOverlayAnimation = gsap
                .timeline({
                    id: 'openCartOverlayAnimation',
                    paused: true,
                    onStart: () => {
                        document.querySelector('cart-drawer').classList.remove('hidden!');
                    },
                    onReverseComplete: () => {
                        document.querySelector('body').classList.remove('overflow-hidden');
                        document.querySelector('cart-drawer').classList.add('hidden!');
                    },
                })
                .fromTo('cart-drawer', { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.01 })
                .addLabel('start')
                .fromTo('#CartDrawer-Overlay', { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5 }, 'start')
                .fromTo(
                    '#CartDrawerContent',
                    { xPercent: 100 },
                    { xPercent: 0, duration: 0.5, ease: 'power2.inOut' },
                    'start',
                );

            openCartOverlayAnimation.play();
        });
    }

    close() {
        setTimeout(() => {
            let openCartOverlayAnimation = gsap
                .timeline({
                    id: 'openCartOverlayAnimation',
                    paused: true,
                    onStart: () => {
                        document.querySelector('cart-drawer').classList.remove('hidden!');
                    },
                    onReverseComplete: () => {
                        document.querySelector('body').classList.remove('overflow-hidden');
                        document.querySelector('cart-drawer').classList.add('hidden!');
                    },
                })
                .fromTo('cart-drawer', { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.01 })
                .addLabel('start')
                .fromTo('#CartDrawer-Overlay', { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5 }, 'start')
                .fromTo(
                    '#CartDrawerContent',
                    { xPercent: 100 },
                    { xPercent: 0, duration: 0.5, ease: 'power2.inOut' },
                    'start',
                );

            openCartOverlayAnimation.reverse(0);
        });
    }

    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute('role', 'button');
        cartDrawerNote.setAttribute('aria-expanded', 'false');

        if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
            cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
        }

        cartDrawerNote.addEventListener('click', (event) => {
            event.currentTarget.setAttribute(
                'aria-expanded',
                !event.currentTarget.closest('details').hasAttribute('open'),
            );
        });

        cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState) {
        this.querySelector('.drawer__inner').classList.contains('is-empty') &&
            this.querySelector('.drawer__inner').classList.remove('is-empty');

        this.productId = parsedState.id;

        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);

            if (!sectionElement) return;
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });

        new Swiper('.cart-swiper', {
            speed: 400,
            spaceBetween: 8,
            slidesPerView: 1.7,
        });

        setTimeout(() => {
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            this.querySelector('#close-cart-drawer').addEventListener('click', this.close.bind(this));

            this.open();
        });

        this.open(); // Opens the cart drawer
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer',
            },
            {
                id: 'cart-icon-bubble',
            },
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '.drawer__inner',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
        ];
    }
}

customElements.define('cart-drawer-items', CartDrawerItems);
